var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingDetail
    ? _c(
        "div",
        { staticClass: "eu-pa_6 eu-align_center" },
        [_c("emd-loader", { attrs: { type: "_invert" } })],
        1
      )
    : _c(
        "div",
        [
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "el-grid-list" }, [
              _c("div", { staticClass: "emd-container" }, [
                _c("div", {
                  staticClass: "emd-status-bar",
                  class: _vm.statusClass(_vm.plan.status),
                }),
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("plan.info.status")) + " ")]
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "emd-badge",
                      class: _vm.statusClass(_vm.plan.status),
                    },
                    [_vm._v(_vm._s(_vm.plan.status))]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("plan.info.billing-type")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(_vm._s(_vm.plan.billing_type)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("plan.info.interval")) + " ")]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("plan.info.interval-each")) +
                        " " +
                        _vm._s(_vm.plan.interval_count) +
                        " " +
                        _vm._s(
                          _vm.pluralIntervals(
                            _vm.plan.interval_count,
                            _vm.plan.interval
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "emd-container" }, [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "emd-text _color_subtle _type_label _size_tiny",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("plan.info.created-at")) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(_vm.plan.created_at, "date")
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "emd-container _highlight_header" }, [
              _c("div", { staticClass: "emd-container__header" }, [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(_vm._s(_vm.$t("plan.info.info"))),
                ]),
              ]),
              _c("div", { staticClass: "emd-container__content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("plan.info.general-data")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [_vm._v(" ID ")]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.plan.id || "-"))]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("plan.info.name")) + " ")]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.plan.name || "-"))]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("plan.info.description")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.plan.description || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _type_label _color_subtle _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("plan.info.currency")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.plan.currency || "-"))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "el-chunk" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "emd-text _type_label _color_subtle _size_tiny",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("plan.info.payment-method")) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._l(
                            _vm.plan.payment_methods,
                            function (payment_method, index) {
                              return _c("span", { key: index }, [
                                _vm._v(
                                  " " + _vm._s(payment_method || "-") + " "
                                ),
                                index !== _vm.plan.payment_methods.length - 1
                                  ? _c("span", [_vm._v(" | ")])
                                  : _vm._e(),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                      _vm.plan.minimum_price
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("plan.info.minimum-price")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.plan.minimum_price || "-")),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.plan.trial_period_days
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("plan.info.trial")) + " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.plan.trial_period_days) + " "),
                              _vm.plan.trial_period_days <= 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("plan.info.trial-day"))
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.plan.trial_period_days > 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("plan.info.trial-days"))
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.plan.updated_at
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("plan.info.updated-at")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.plan.updated_at,
                                    "dateAndHour"
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.plan.metadata &&
                      Object.entries(_vm.plan.metadata).length
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("plan.info.more-info")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("pre", [_vm._v(_vm._s(_vm.plan.metadata))]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm.plan.items.length
              ? _c("div", { staticClass: "el-section" }, [
                  _c(
                    "div",
                    { staticClass: "emd-container _highlight_header" },
                    [
                      _c("div", { staticClass: "emd-container__header" }, [
                        _c("h2", { staticClass: "emd-text _size_section" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("plan.info.items.title")) + " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "emd-table-responsive" }, [
                        _c("table", { staticClass: "emd-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("plan.info.items.name"))),
                              ]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("plan.info.items.status"))
                                ),
                              ]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("plan.info.items.quantity"))
                                ),
                              ]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("plan.info.items.scheme"))
                                ),
                              ]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("plan.info.items.amount"))
                                ),
                              ]),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("plan.info.items.updated-at"))
                                ),
                              ]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.plan.items, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.name"
                                      ),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.name || "-") + " ")]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.status"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(item.status || "-") + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.quantity"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(item.quantity || "-") + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.scheme"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.pricing_scheme.scheme_type || "-"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.amount"
                                      ),
                                    },
                                  },
                                  [
                                    item.pricing_scheme.price_brackets.length
                                      ? _c(
                                          "div",
                                          [
                                            _vm._l(
                                              item.pricing_scheme
                                                .price_brackets,
                                              function (price, index) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: index,
                                                    staticClass: "eu-pb_2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "plan.info.items.interval-from"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          price.start_quantity
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "plan.info.items.interval-to"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          price.end_quantity
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "eu-mr_1 eu-ml_1 uil uil-arrow-right",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "emd-text _type_caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(price.price)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "eu-pb_2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "plan.info.items.interval-over"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.lastPrice(
                                                        item.pricing_scheme
                                                          .price_brackets
                                                      ).end_quantity
                                                    ) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "eu-mr_1 eu-ml_1 uil uil-arrow-right",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "emd-text _type_caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lastPrice(
                                                          item.pricing_scheme
                                                            .price_brackets
                                                        ).overage_price
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.pricing_scheme.price || "-"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      "data-label": _vm.$t(
                                        "plan.info.items.updated-at"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            item.updated_at,
                                            "dateAndHour"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _c("log-links", {
            attrs: { entity: _vm.plan, title: _vm.$t("log-links.plan") },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }